// Loosely-typed relationship helpers to avoid strict coupling across model layers
type AnyRecord = Record<string, any>;

export async function populateRelationshipFromRequests(params: {
  list: AnyRecord[];
  idKey: string;
  newKey: string;
  func: (id: any) => Promise<any> | any;
}): Promise<any> {
  const { list, idKey, newKey, func } = params;
  const ids = list.map((item) => item[idKey]);
  const uniqueIds = Array.from(new Set(ids));
  const relatedItems = await Promise.all(uniqueIds.map((id) => func(id)));
  const result = list.map((item) => {
    const related = relatedItems.find((relatedItem) => relatedItem?.id === item[idKey]);
    return { ...item, [newKey]: related };
  });
  return result as any;
}

export async function populateRelationshipFromRequest(params: {
  list: AnyRecord[];
  idKey: string;
  newKey: string;
  func: (ids: any[]) => Promise<any[]> | any[];
  foreignKey?: string;
}): Promise<any> {
  const { list, idKey, newKey, func, foreignKey = 'id' } = params;
  const ids = list.map((item) => item[idKey]);
  const uniqueIds = Array.from(new Set(ids)).filter((id) => id != null);
  if (uniqueIds.length === 0) return list;
  const relatedItems = await func(uniqueIds);
  const items = Array.isArray(relatedItems) ? relatedItems : [relatedItems];
  const result = list.map((item) => {
    const related = items.find((relatedItem) => relatedItem?.[foreignKey] === item[idKey]);
    return { ...item, [newKey]: related };
  });
  return result as any;
}

export async function populateHasManyRelationshipFromRequest(params: {
  list: AnyRecord[];
  idKey: string;
  newKey: string;
  func: (ids: any[]) => Promise<any[]> | any[];
  foreignKey?: string;
}): Promise<any> {
  const { list, idKey, newKey, func, foreignKey = 'id' } = params;
  const ids = list.map((item) => item[idKey]);
  const uniqueIds = Array.from(new Set(ids));
  if (uniqueIds.length === 0) return list.map((item) => ({ ...item, [newKey]: [] })) as any;
  const relatedItems = await func(uniqueIds);
  const result = list.map((item) => {
    const related = relatedItems.filter((relatedItem) => relatedItem?.[foreignKey] === item[idKey]);
    return { ...item, [newKey]: related };
  });
  return result as any;
}


